/**
	Раньше этот файл назывался getEditorConfig.js

	Описание (в том числе отличия от дистрибутива!)
		https://wiki.oooinex.ru/pages/viewpage.action?pageId=17891790

	Какие бывают типы контролов/виджетов (type, что указывается в editor.windowManager.open)
		http://archive.tinymce.com/wiki.php/api4:class.tinymce.ui.Form

	Как прибить все tinymce на странице
		window.tinyMCE.remove();
*/

export default getEditorConfig;

window.UARM_TMCE_UTIL = window.UARM_TMCE_UTIL || {};

import addPluginForAsyncElement from './addPluginForAsyncElement.js';
import { replaceQuotesMain } from './replace.quotes.module.js';
import { applyTypograph } from './typograph.module.js';

let pluginsInitNeeded = true; // ахтунг! плагины подключаются глобально один раз в pluginsInit
const idCtrlName = 'id_inp'; // имя контрола ввода айди чего-либо, исп. в презентациях/фоторепортажах

function changeUlStyleWhenAdd(ed) {
	const thisUL = ed.dom.getParent(ed.selection.getNode(), 'UL, OL');
	const parentUL = thisUL?.parentNode.closest('UL, OL');
	if (parentUL) {
		if (parentUL.classList.length === 0) {
			thisUL.classList.add('pList');
		} else {
			thisUL.classList.remove('pList');
		}
	}
}

function pluginsInit() {
	if (pluginsInitNeeded) {
		pluginsInitNeeded = false;

		require('./lang-ru.js');

		// Иконки и картинки
		// нормально зареквайрить иконки собирая путь к ней не удалось, пока так:
		require('@uarm/public/images/tinymce-icons_icon.png');
		require('@uarm/public/images/tinymce-icons_big.png');
		require('@uarm/public/images/tinymce-typograph.png');
		require('@uarm/public/images/tinymce-pion_icon.png');
		require('@uarm/public/images/tinymce-pion_big.png');
		require('@uarm/public/images/tinymce-livecharts_icon.png');
		require('@uarm/public/images/tinymce-livecharts_big.png');
		require('@uarm/public/images/tinymce-photoreports_icon.png');
		require('@uarm/public/images/tinymce-photoreports_big.png');
		require('@uarm/public/images/tinymce-imaps_icon.png');
		require('@uarm/public/images/tinymce-imaps_big.png');
		require('@uarm/public/images/tinymce-eye_plus.png');
		require('@uarm/public/images/tinymce-eye_blocked.png');
		require('@uarm/public/images/tinymce-ulstyle.png');
		require('@uarm/public/images/tinymce-k11.gif');
		require('@uarm/public/images/tinymce-k21.gif');
		require('@uarm/public/images/tinymce-quote.gif');
		require('@uarm/public/images/tinymce-quote-new.png');
		require('@uarm/public/images/tinymce-marquee.gif');
		require('@uarm/public/images/tinymce-hrred.png');
		require('@uarm/public/images/tinymce-nobr.png');

		require('@uarm/public/images/tinymce/info.svg');
		require('@uarm/public/images/tinymce/cancel-close.svg');
		require('@uarm/public/images/tinymce/text-width.svg');
		require('@uarm/public/images/tinymce/eye-plus.svg');
		require('@uarm/public/images/tinymce/eye-off-line.svg');

		require('@uarm/public/images/tinymce/pictures.svg');
		require('@uarm/public/images/tinymce/data-graph-chart-report.svg');
		require('@uarm/public/images/tinymce/quote.svg');
		require('@uarm/public/images/tinymce/presentation-exhibition.svg');
		require('@uarm/public/images/tinymce/one-back.svg');
		require('@uarm/public/images/tinymce/map-with-a-location-pointer.svg');
		require('@uarm/public/images/tinymce/letter-a-text-variant.svg');
		require('@uarm/public/images/tinymce/icon.svg');
		require('@uarm/public/images/tinymce/tooltip.svg');
		require('@uarm/public/images/tinymce/tooltip-remove.svg');

		// ---------------------------------
		// Встроенные (и неизменные) плагины
		// ---------------------------------
		// require('tinymce/plugins/code');
		require('tinymce/plugins/hr');
		// require('tinymce/plugins/table');
		require('tinymce/plugins/fullscreen');
		require('tinymce/plugins/lists');
		require('tinymce/plugins/colorpicker');
		require('tinymce/plugins/paste');
		require('tinymce/plugins/searchreplace');

		// ------------------------------------
		// Встроенные (но пропатченные) плагины
		// ------------------------------------
		require('./plugins/media/plugin.js');
		require('./plugins/link/plugin.js');
		require('./plugins/image/plugin.js');
		require('./plugins/spoiler/plugin.js');
		require('./plugins/legacyoutput/plugin.js');
		require('./plugins/table/plugin.js');
		require('./plugins/term/plugin.js');
		require('./plugins/abbreviation/plugin.js');
		require('./plugins/numeralsdigits/plugin.js');
		require('./plugins/codemod/plugin.js');

		require('./plugins/tooltip/plugin.js');

		// ---------------------------
		// Полностью кастомные плагины
		// ---------------------------
		addPluginForAsyncElement({
			// Плагин выбора и вставки интерактивной карты
			name: 'imaps',
			buttonTitleSuffix: 'интерактивную карту',
			windowTitleSuffix: 'интерактивной карты',
		});
		addPluginForAsyncElement({
			// Плагин выбора и вставки фоторепортажа
			name: 'photoreports',
			buttonTitleSuffix: 'фоторепортаж',
			windowTitleSuffix: 'фоторепортажа',
		});
		addPluginForAsyncElement({
			// Плагин выбора и вставки интерактивной презентации
			name: 'pion',
			buttonTitleSuffix: 'презентацию',
			windowTitleSuffix: 'презентации',
		});
		addPluginForAsyncElement({
			// Плагин выбора и вставки живых графиков
			name: 'livecharts',
			buttonTitleSuffix: '"живой" график',
			windowTitleSuffix: '"живого" графика',
		});
		addPluginForAsyncElement({
			// Плагин выбора и вставки иконки
			name: 'icons',
			buttonTitleSuffix: 'иконку',
			windowTitleSuffix: 'иконки',
		});

		// ---------------------------
		// Дополнения к плагинам
		// ---------------------------
		require('./table2');
		require('./table-sorting-paging.js');
	}
}

function getEditorConfig(vm, CTRL_ID) {
	// ахтунг! в vm ещё нету $data, поэтому и передаю CTRL_ID

	const ctrlParams = vm.$props.field_meta.ctrlParams;
	const vpId = vm.$route.params.vpId;

	const isEmail = !!ctrlParams.isEmail;
	const baseURL = '/uarm-fe/tinymce-assets/';

	const isLinkAnalyzed = vm.$route.query.hasOwnProperty('linkAnalyzed') ? Boolean(vm.$route.query.linkAnalyzed) : false;

	pluginsInit(); // инициализация плагинов, случается один раз

	let toolBarSecondRow = 'table hr hrred | image';
	if (isEmail === false) {
		toolBarSecondRow += ' media';
	}
	toolBarSecondRow += ' link';
	if (isEmail === false) {
		toolBarSecondRow +=
			' | livecharts_btn pion_btn icons_btn photoreports_btn imaps_btn | runingstring nobr | spoiler-add spoiler-remove | abbr term |';
	}
	toolBarSecondRow +=
		' replace_quote to_plain_text purge_text purge_markup typograph | tooltip tooltip-remove | fullscreen codemod';

	let content_css = '/uarm-fe/uarm-css/tinymce/innerStyle-base.css';
	if (isEmail === false) {
		content_css += ', /st/css/adaptive/wysiwyg.css, /uarm-fe/uarm-css/tinymce/innerStyle.css';
	}

	let body_class = 'wysiwyg-body-class static-content';
	if (isLinkAnalyzed) {
		body_class += ' static-content-link-analyzed';
	}
	if (localStorage.getItem('theme')) {
		body_class += ` v-theme--${localStorage.getItem('theme')}`;
	}

	const theme = localStorage.getItem('theme');
	if (theme) {
		body_class += ` v-theme--${theme}`;
	}

	const CFG = {
		// см. http://www.tinymce.com/wiki.php/configuration
		height: ctrlParams.isCompact ? 200 : 500,
		skin_url: '/uarm-fe/uarm-css/tinymce', // тинимце сам дописывает skin.min.css
		submit_patch: isEmail === false, // ахтунг! этот код работает только в связке с triggerSave из common-arm.js
		language: 'ru',
		body_class,
		body_id: 'wysiwyg-body-id', // иначе с айди равным tinymce глобальная переменная tinymce затирается
		menubar: false,
		plugins: `numdigit abbr term spoiler codemod tooltip hr table image media link livecharts photoreports lists pion icons fullscreen searchreplace imaps colorpicker paste${
			isEmail ? ' legacyoutput' : ''
		}`, // https://www.tinymce.com/docs/plugins/legacyoutput/
		toolbar: [
			// http://www.tinymce.com/wiki.php/Controls
			// здесь перечиляются названия стандартных кнопок, названия плагинов из списка выше, названия кнопок из addButton ниже
			'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | superscript subscript | bullist numlist changeulstyle | outdent indent ',
			toolBarSecondRow,
		],
		//PIRS-f661
		extended_valid_elements:
			'a[name|onclick|rel|href|target|title|class],script[language|type|src],marquee,span[*],table[bgcolor<FAKEVALUE|*],td[bgcolor<FAKEVALUE|*],div[id|style|class|onclick],svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*],button[*],nobr',
		/*
			Синтаксис extended_valid_elements - здесь http://www.tinymce.com/wiki.php/Configuration:valid_elements
			Почему FAKEVALUE - потому что только такой конструкцией можно сделать принудительное удаление атрибута см. JIRA SUPPORT-192 (типа, при значениях атрибута bgcolor отличных от FAKEVALUE он будет удаляться)
			Все остальные атрибуты запрещены звёздочкой.
			Можно было бы с тем же эффектом написать @[bgcolor<FAKEVALUE|*],table,td - но это уж совсем напоминает регулярку. Оставил более понятный вариант.
		*/
		content_css,
		invalid_elements: 'script,iframe',

		style_formats: [
			/**
				http://www.tinymce.com/wiki.php/Configuration:style_formats
				@inline – Name of the inline element to produce for example “span”. The current text selection will be wrapped in this inline element.
				@block – Name of the block element to produce for example “h1″. Existing block elements within the selection gets replaced with the new block element.
				@selector – CSS 3 selector pattern to find elements within the selection by. This can be used to apply classes to specific elements or complex things like odd rows in a table.
				@classes – Space separated list of classes to apply the the selected elements or the new inline/block element.
				@styles – Name/value object with CSS tyle items to apply such as color etc.
				@attributes – Name/value object with attributes to apply to the selected elements or the new inline/block element.
				@exact – Disables the merge similar styles feature when used. This is needed for some CSS inheritance issues such as text-decoration for underline/strikethough.
				@wrapper – State that tells that the current format is a container format for block elements. For example a div wrapper or blockquote.
			*/
			{
				title: 'Текст',
				block: 'p',
				attributes: {
					class: '',
				},
			},
			{
				title: 'Подзаголовок',
				block: 'h2',
			},
			{
				title: 'Примечание',
				block: 'p',
				attributes: {
					class: 'small',
				},
			},
			{
				title: 'Микро',
				block: 'p',
				attributes: {
					class: 'micro',
				},
			},
			{
				title: 'Информер',
				block: 'p',
				attributes: {
					class: 'informer',
				},
			},
			{
				title: '(i) Текст с отступом',
				block: 'p',
				attributes: {
					class: 'ident',
				},
			},
			{
				title: 'ПОДЗАГОЛОВОК ЧЕРНЫЙ',
				block: 'p',
				attributes: {
					class: 'upper',
				},
			},
			{
				title: 'ПОДЗАГОЛОВОК КРАСНЫЙ',
				block: 'p',
				attributes: {
					class: 'uppercolored',
				},
			},
			{
				title: 'Метка на красном фоне',
				block: 'p',
				inline: 'span',
				attributes: {
					class: 'red-label',
				},
			},
		],
		// почему классы записаны как атрибуты, а не как classes? А потому что иначе выбрав две опции можно было сделать параграф с двумя классами типа epigraph и ident, что неправильно, см. PIRS-6827
		// PIRS-14661
		formats: {
			removeformat: [
				{
					selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
					remove: 'all',
					split: true,
					expand: false,
					block_expand: true,
					deep: true,
				},
				{
					selector: 'span',
					attributes: ['style', 'class'],
					remove: 'empty',
					split: true,
					expand: false,
					deep: true,
				},
				{
					selector: '*',
					attributes: ['style', 'class'],
					split: false,
					expand: false,
					deep: true,
				},
			],
		},
		/* ____________ Настройки плагинов _____________ */
		image_advtab: true, // вкладка Дополнительно для картинок, с отступами и прочим - нужно для отступов (SUPPORT-2670)
		media_alt_source: false, // поле медиа "альтернативный источник"
		media_poster: true, // поле медиа "обложка" ("изображение") // INEX клиенту требовалось добавить постер к видео
		link_class_list: (function () {
			return ['51', '68', '67'].indexOf(vpId) !== -1
				? [
						{
							title: 'Обычная ссылка',
							value: 'regularlink',
						},
						{
							title: 'Выделенная ссылка',
							value: 'highlitelink',
						},
				  ]
				: [
						{
							title: 'Серая ссылка',
							value: 'graylink',
						},
						{
							title: 'Красная ссылка',
							value: 'redlink',
						},
						{
							title: 'Красная без иконки',
							value: 'redlink noicon',
						},
						{
							title: 'Серая без иконки',
							value: 'graylink noicon',
						},
						// скрыто в рамках PIRS2018-3035:
						// {
						// 	title: 'Обычная ссылка',
						// 	value: 'regularlink'
						// },
						// {
						// 	title: 'Обычная без иконки',
						// 	value: 'regularlink noicon'
						// }
				  ];
		})(),
		link_title: false, // поле ссылки "заголовок"
		target_list: [
			{
				title: 'В текущем окне',
				value: '_self',
			},
			{
				title: 'В новом окне',
				value: '_blank',
			},
		],
		convert_urls: false, // иначе в относительные урлы дописывается куча ../../../../../

		table_advtab: false, // вкладка Дополнительно с бордерколором, бэкграундколором и полем ввода инлайн стиля

		table_cell_advtab: false, // такая же вкладка Дополнительно, но для параметров ячейки

		table_row_advtab: false, // такая же вкладка Дополнительно, но для параметров строки, см. PIRS-6910 п.1

		table_class_list: [
			{ title: 'На белом фоне', value: 'Striped table' },
			{ title: 'Без фона', value: 'Striped table table_no-bg' },
		],
		/*
			table_cell_class_list: 	[{title: 'None', value: ''}],
			table_row_class_list: 	[{title: 'None', value: ''}],
		*/
		table_default_attributes: {
			class: 'Striped table',
		},
		// preview_styles:true,

		// Плагин paste
		// документация - см. http://www.tinymce.com/wiki.php/Plugin:paste
		// почему он нужен - см. http://jira.oooinex.ru/browse/PIRS-7323
		// paste_as_text: true,

		paste_preprocess(plugin, args) {
			args.content = args.content.replace(/<table(.*?)>/gi, '<table $1 class="Striped">');
			args.content = args.content.replace(/\u00a0/gi, ' ');
			args.content = args.content.replace(/&nbsp;/gi, ' ');
		},
		branding: false,
		setup(ed) {
			// События редактора ТиниМЦЕ
			// https://www.tiny.cloud/docs-4x/advanced/events/

			if (window.localStorage['tinymce-events-debug']) {
				ed.on('focus blur input change keyup keydown dirty', function (evt) {
					console.log(`tinymce-events-debug: ${evt.type}`, evt);
				});
			}

			ed.on('blur', function (evt) {
				vm.mixin_saveEvent(); // сохранение из списка по потере фокуса
			});

			ed.on('input', function (evt) {
				// window.setTimeout(vm.mixin_inputEvent, 300) // setTimeout - грубый хак, потому что то ли вуй, то ли (скорее) тинимце обновляет значение не сразу при вводе (и не сразу при change) и случается PIRS2018-3541
				// причём актуальный контент можно получить сразу здесь ed.getContent()
				// инпут не срабатывает если нажать enter
				// ченж в визарде работает, а в браузере нет
				// респект разрабам, в общем)
			});
			ed.on('OpenWindow', function (e) {
				/*
					Данная штучка (tinymce) не может кастомизировать модальные окна из коробки
					подвязываемся к открытию модалки и меняем ей заголовок

					респект разрабам, в общем ^_^
				 */
				const dangerText = '(теги script и iframe будут удалены)'; // текст который добавляется к текущему заголовку
				const staticObjOptions = [
					{ selector: '.mce-title', title: 'Исходный код' /* Заголовок по умолчанию */ },
					{ selector: '.mce-label', title: 'Вставьте ваш код ниже:' },
				];

				staticObjOptions.forEach((header) => {
					const modalTitle = Array.from(document.querySelectorAll(header.selector));
					if (modalTitle.length) {
						const findElDom = modalTitle.find((elDom) => elDom.innerText === header.title);
						findElDom ? (findElDom.innerText += ` ${dangerText}`) : null;
					}
				});
			});
			ed.on('keyup', function (e) {
				// нормальное удаление спана по схеме "клик (элемент выделен),
				// затем делит" почему-то не работает, поэтому руками
				// конкретно для фоторепортажей и презентаций запоминаем элемент, получивший фокус
				// а вручную назначенный обработчик нажатия делита удаляет его (элемент)
				if (e.keyCode === 46 && window.UARM_TINYMCE_FOCUSED_EL) {
					window.UARM_TINYMCE_FOCUSED_EL.remove();
				}
				if (e.keyCode === 9) {
					changeUlStyleWhenAdd(this);
				}
			});

			ed.on('ExecCommand', function (e) {
				if (e.command === 'Indent') {
					changeUlStyleWhenAdd(this);
				}
			});

			// Кнопки ниже просто перенесены из старого кода
			ed.addButton('runingstring', {
				title: 'Бегущая строка',
				image: '/uarm-fe/uarm-images/letter-a-text-variant.svg',
				class: 'class-for-theme',
				onclick() {
					ed.focus();
					let newContent = 'Нужно сначала написать текст, выделить его, а затем нажать кнопку бегущая строка.';
					if (!/^$\s*$/.test(ed.selection.getContent())) {
						newContent = ed.selection.getContent();
					}
					ed.selection.setContent(`<marquee>${newContent}</marquee>`);
					ed.undoManager.add();
				},
			});

			const isEngSite = Number(vpId) === 68 || Number(vpId) === 112;
			const quoteBtnTitle = isEngSite ? 'Заменить на двойные кавычки' : 'Заменить на кавычки «ёлочки»';
			const quoteBtnImage = isEngSite ? '/uarm-fe/uarm-images/tinymce-quote.gif' : '/uarm-fe/uarm-images/quote.svg';

			ed.addButton('replace_quote', {
				title: quoteBtnTitle,
				image: quoteBtnImage,
				onclick() {
					const str = ed.getContent();
					// PIRS-14661
					// Код берёт кавычки внутри онклика и заменяет на magic string
					// Затем, после замены всех кавычек в документе, magic string заменяется обратно на одинарные кавычки
					// Затем, преобразуем обычные кавычки в кавычки «ёлочки» - PIRS2018-3032
					// Тестовая строка
					// <div class="test"><p><a href='https://стопкоронавирус.рф' class='redlink'>'dsada"</a></p></div>
					// <p class="MsoNormal" style="margin: 0cm 0cm 0pt; text-align: center;" align="center"><strong><span style="font-size: 10pt; font-family: Verdana;">Конкурсная документация <!--?xml:namespace prefix = o ns = "urn:schemas-microsoft-com:office:office" ?--></span></strong></p>
					if (str) {
						ed.setContent(replaceQuotesMain(str, isEngSite));
					}

					ed.undoManager.add();
				},
			});

			// Очистка текста: "мягкий" вариант
			ed.addButton('purge_text', {
				title: 'Очистка формата текста',
				image: '/uarm-fe/uarm-images/info.svg',
				onclick() {
					purgeContent(false);
				},
			});

			// Очистка текста: "жесткий" вариант
			ed.addButton('purge_markup', {
				title: 'Удаление разметки',
				image: '/uarm-fe/uarm-images/cancel-close.svg',
				onclick() {
					purgeContent(true);
				},
			});

			function purgeContent(napalmFlag) {
				const hasSelection = ed.selection.getContent().length !== 0;
				const word_subject = hasSelection === true ? 'выделенного фрагмента' : 'всего документа';
				const word_action = napalmFlag === true ? 'полностью' : 'частично';
				if (
					window.confirm(`Вы действительно хотите ${word_action} удалить форматирование ${word_subject}?`) === false
				) {
					return;
				}
				ed.focus();

				if (napalmFlag === true) {
					// жёсткое удаление - убиваем все теги, а на образовавшиеся абзацы заключаем в параграфы
					const tgt = hasSelection === true ? ed.selection : ed;
					const newContent = tgt
						.getContent()
						.replace(/<[^>]*>/g, '')
						.replace(/(((\s|&nbsp;)*(\r\n)|\r|\n)(\s|&nbsp;)*)+/g, '</p><p>')
						.replace(/(&nbsp;)+/gi, ' ');
					tgt.setContent(newContent);
				} else {
					// мягкое удаление - чистятся классы-атрибуты-болд-италик (стандартная функция) плюс кой-чего ещё (см. ниже)
					if (hasSelection === true) {
						// применяем стандартную функцию к выделению
						ed.execCommand('removeformat');
					} else {
						// применяем стандартную функцию ко всему документу
						// PIRS-14661
						// если редакторы отфарматируют все - перестанет работать
						// скрипт старого спойлера
						alert('Выделите фрагмент текста для снятия форматирования');
						/*ed.execCommand('selectall');
						ed.execCommand('removeformat');
						ed.execCommand('unselect');*/
					}

					/*
						НЕЗАВИСИМО от того, выбран ли целью фрагмент или весь документ:
						1. удаляем ВЕЗДЕ пустые параграфы (см. PIRS-7607)
						2. приводим классы ВСЕХ таблиц (потому что стандартная функция только что их стёрла) к Striped (см. PIRS-7653)
						3. прибиваем повторяющиеся пробелы включая неразрывные
					*/
					// TODO выкинуть жиквери
					const $bo = window.$(ed.getBody());
					$bo
						.find('p')
						.filter(function () {
							// средствами tinyMCE решить задачу удаления пустых (визуально) строк не удалось (кастомный формат c split=true не канает)
							const purgedContent = window
								.$(this)
								.html()
								.replace(/(<br data-mce-bogus="1">)|(&nbsp;)|(\s)/g, ''); // если кроме пробелов и тинимцешных плейсхолдеров в параграфе ничего нет - удаляем

							return purgedContent === '';
						})
						.remove();
					$bo.find('table').addClass('Striped');

					//PIRS-14661 & PIRS-16721 чтобы не удаляло скрипты
					//$bo.html($bo.html().replace(/(&nbsp;)/g, ' ').replace(/\s\s+/g, ' ')); // прибиваем повторяющиеся пробелы (включая неразрывные)
					const newSelectTxt = ed.selection
						.getContent()
						.replace(/(&nbsp;)/g, ' ')
						.replace(/\s\s+/g, ' ');
					ed.selection.setContent(newSelectTxt);
				}
			}

			ed.addButton('changeulstyle', {
				title: 'Изменить стиль списка',
				image: '/uarm-fe/uarm-images/one-back.svg',
				onclick() {
					let thisUL = ed.dom.getParent(ed.selection.getNode(), 'UL');
					if (thisUL) {
						if (ed.dom.getAttrib(thisUL, 'class') == 'pList') ed.dom.setAttrib(thisUL, 'class', '');
						else ed.dom.setAttrib(thisUL, 'class', 'pList');
					} else {
						thisUL = ed.dom.getParent(ed.selection.getNode(), 'OL');
						const className = ed.dom.getAttrib(thisUL, 'class');

						if (className == 'pList') ed.dom.setAttrib(thisUL, 'class', '');
						else if (className == 'pList2') ed.dom.setAttrib(thisUL, 'class', 'pList');
						else ed.dom.setAttrib(thisUL, 'class', 'pList2');
					}

					ed.undoManager.add();
				},
			});

			ed.addButton('nobr', {
				title: 'Не переносить слова',
				image: '/uarm-fe/uarm-images/text-width.svg',
				onclick() {
					ed.focus();

					const parent = ed.dom.getParent(ed.selection.getNode());
					const className = ed.dom.getAttrib(parent, 'class');

					if (className.indexOf('nobr') > -1) {
						ed.dom.setAttrib(parent, 'class', className.replace(/nobr/gi, ''));
					} else {
						ed.dom.setAttrib(parent, 'class', `${className + (className.length ? ' ' : '')}nobr`);
					}

					ed.undoManager.add();
				},
			});

			ed.addButton('hrred', {
				title: 'Красная горизонтальная линия',
				image: '/uarm-fe/uarm-images/tinymce-hrred.png',
				onclick() {
					ed.focus();
					ed.selection.setContent('<hr class="red"/>');
					ed.undoManager.add();
				},
			});

			ed.addButton('typograph', {
				title:
					'Будут изменены кавычки, формат даты и времени, дефисы/тире, расставлены/удалены пробелы, поправлены сокращения, удалена буква Ё и т.п.',
				image: '/uarm-fe/uarm-images/tinymce-typograph.png',
				icon: 'mce-ico-typograph',
				onclick() {
					if (window.confirm(`Применить экранную типографику?`) === false) {
						return;
					}
					const str = ed.getContent();
					if (str) {
						ed.setContent(applyTypograph(str, isEngSite));
					}
					ed.undoManager.add();
				},
			});
		},
	};

	return CFG;
}
